/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md:
   this file exports a function, not a React component. */
import type { ExportColumn } from './export-column.js';
import { formatExportValue } from './format-export-value.js';
import { hasFormulaPrefix } from './has-formula-prefix.js';

// Without a UTF-8 BOM, Excel decodes a CSV as the legacy codepage and mangles accents.
const UTF8_BOM = '﻿';

// RFC 4180 record separator -- Excel splits on bare LF too, but writes CRLF itself.
const RECORD_SEPARATOR = '\r\n';

function escapeCsvField(text: string): string {
  // CSV cells are untyped, so Excel would run a formula on open; a leading tab defeats it.
  const safe = hasFormulaPrefix(text) ? `\t${text}` : text;
  // Quoting a tab keeps a parser that trims unquoted whitespace from stripping the formula guard.
  return /["\n\r,\t]/.test(safe) ? `"${safe.replaceAll('"', '""')}"` : safe;
}

export function buildCsv<TData>(
  columns: readonly ExportColumn<TData>[],
  rows: readonly TData[],
): string {
  const header = columns.map((column) => escapeCsvField(column.label));
  const body = rows.map((row, index) =>
    columns.map((column) =>
      escapeCsvField(formatExportValue(column.getValue(row, index), column.exportType).text),
    ),
  );
  return UTF8_BOM + [header, ...body].map((cells) => cells.join(',')).join(RECORD_SEPARATOR);
}
